export default __webpack_public_path__ + "static/media/updated-sidebar.4c05343f.png";